export const AsignTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'organization',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: 'Razon social',
                    type: 'custom-html',
                    key: 'organization',
                    modifier: (value) => {
                        return value.business_name;
                    }
                },
                {
                    title: 'Usuario',
                    type: 'custom-html',
                    key: 'user',
                    modifier: (value) => {
                        return value.full_name;
                    }
                },
                {
                    title: this.$t('Tipo'),
                    type: 'custom-html',
                    key: 'accreditation_activity',
                    modifier: (value) => {
                        return value.name;
                    }
                },

                // {
                //     title: this.$t('Actividad'),
                //     type: 'custom-html',
                //     key: 'accreditation_type',
                //     modifier: (value) => {
                //         return value.name;
                //     }
                // },

                {
                    title: this.$t('Fecha de envío'),
                    type: 'custom-html',
                    key: 'created_at',
                    modifier: (value) => {
                        if (value) {
                            return moment(value).format("YYYY-MM-DD");
                        }
                    }
                },
                {
                    title: this.$t('Estado de Pago'),
                    type: 'custom-html',
                    key: 'acc_app_id',
                    modifier: (value) => {
                        let tmp;
                        if (value) {
                            tmp = `<span class="badge badge-sm badge-pill badge-success">ADQUISICIÓN</span>`;
                        } else {
                            tmp = `<span class="badge badge-sm badge-pill badge-success">RENOVACIÓN</span>`;
                        }

                        return tmp;
                    }
                },

                // {
                //     title: 'Estado',
                //     type: 'custom-html',
                //     key: 'status',
                //     isVisible: true,
                //     modifier: (value) => {
                //         return value.name;

                //     }
                // },
                // {
                //     title: 'Días Disponibles',
                //     type: 'custom-html',
                //     key: 'accreditation_time',
                //     modifier: (value) => {
                //         let tmp;
                //         if (value) {
                //             if (value.remaining_days > 1) {
                //                 tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
                //             }
                //             if (value.remaining_days == 1) {
                //                 tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
                //             }
                //             if (value.remaining_days == 0) {
                //                 tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
                //             }
                //         }
                //         return tmp;
                //     }
                // },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}